export enum EventTypeEnum {
  Public = 'public',
  NonPublic = 'nonPublic',
  OnlyMembers = 'onlyMembers',
}
